// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__13cUs","sendOtp":"AuthorizeToLogin_sendOtp__3omHc"};